import {makeAutoObservable} from "mobx";

class OrderListStore {
    list = [];
    pageSize = 10000;
    pageNum = 1;
    showDeliveryMap = new Map();
    ifShowDeliveryModal = false;
    currentDelivery = undefined;
    currentOrder = undefined;

    constructor() {
        makeAutoObservable(this)
    }

    showDelivery(orderId) {
        this.showDeliveryMap.set(orderId, true);
    }

    hideDelivery(orderId) {
        this.showDeliveryMap.set(orderId, false);
    }

    showDeliveryModal(orderId) {
        if (!this.list.length) {
            return undefined;
        }

        this.currentOrder = this.list.find(({id}) => id === orderId);

        this.currentDelivery = this.currentOrder?.delivery;

        this.ifShowDeliveryModal = true;
    }

    closeDeliveryModal() {
        this.ifShowDeliveryModal = false;
    }

}

export default new OrderListStore();